import React, { useState, useEffect } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, VStack, FormControl, FormLabel, Select, Text, useToast,
} from '@chakra-ui/react';
import api from '../api';

const STATUS_LABELS = {
  to_invoice:'To Invoice', created_not_sent:'Created (Not Sent)', po_requested:'PO Requested',
  po_issued:'PO Issued', sent_for_payment:'Sent for Payment',
  invoiced_within_terms:'Invoiced', paid_in_part:'Part Paid',
  paid_in_full:'Paid in Full', overdue:'Overdue', very_overdue:'Very Overdue',
  written_off:'Written Off', send_for_debt_collection:'Debt Collection',
  quotation:'Quotation (Sent)', quotation_not_sent:'Quotation (Not Sent)', contracted:'Contracted', pay_now:'Pay Now',
  projected:'Projected', receipt:'Receipt', opportunity_value:'Opportunity Value',
};

export default function CloneSettingsModal({ isOpen, onClose }) {
  const [cloneInvoiceStatus, setCloneInvoiceStatus] = useState('quotation');
  const toast = useToast();

  useEffect(() => {
    if (isOpen) {
      (async () => {
        try { const { data } = await api.get('/projects/settings/clone_invoice_status'); if (data) setCloneInvoiceStatus(data.setting_value || 'quotation'); } catch(e) {}
      })();
    }
  }, [isOpen]);

  const handleSave = async () => {
    try {
      await api.put('/projects/settings/clone_invoice_status', { value: cloneInvoiceStatus });
      toast({ title: 'Settings saved', status: 'success', duration: 1500 });
      onClose();
    } catch(e) { toast({ title: 'Failed', status: 'error', duration: 2000 }); }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" isCentered>
      <ModalOverlay /><ModalContent>
        <ModalHeader fontSize="md">Project Templates / Clones</ModalHeader><ModalCloseButton />
        <ModalBody>
          <VStack spacing={3}>
            <Text fontSize="11px" color="gray.500">When cloning a project or using a template, invoices are duplicated with the status set below.</Text>
            <FormControl>
              <FormLabel fontSize="xs" mb={0.5}>Default Invoice Status for Clones</FormLabel>
              <Select size="sm" value={cloneInvoiceStatus} onChange={e => setCloneInvoiceStatus(e.target.value)}>
                {Object.entries(STATUS_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </Select>
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" variant="ghost" mr={2} onClick={onClose}>Cancel</Button>
          <Button size="sm" colorScheme="teal" onClick={handleSave}>Save</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
